import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var IconHazardousWasteAndDetoxification = function IconHazardousWasteAndDetoxification(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '48px' : _ref$size,
      props = _objectWithoutProperties(_ref, ["color", "size"]);

  return (
    /*#__PURE__*/
    React.createElement(Icon, props,
    /*#__PURE__*/
    React.createElement("svg", {
      viewBox: "0 0 48 48",
      fill: "none",
      width: size,
      height: size
    },
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M31.895 7.556A5 5 0 0027.529 5H20.47l-.236.005a5 5 0 00-4.238 2.758L15.38 9H11v6h26V9h-4.38l-.615-1.235-.11-.209zM30.386 9l-.17-.342a3 3 0 00-2.486-1.652L27.53 7h-7.06a3 3 0 00-2.59 1.48l-.095.175-.171.345h12.772zM35 13v-2H13v2h22zm-22 3.89h22v26H13v-26zm20 24v-22H15v22h18zM31 21v1H17v-1h14zm0 18v-1H17v1h14zm-5.586-9.11l3.293 3.293-1.414 1.414L24 31.304l-3.293 3.293-1.414-1.414 3.293-3.293-3.293-3.293 1.414-1.414L24 28.476l3.293-3.293 1.414 1.414-3.293 3.293z",
      fill: color
    })))
  );
};

export default IconHazardousWasteAndDetoxification;
export { IconHazardousWasteAndDetoxification };